import { render, staticRenderFns } from "./CustomerChangeEdit.vue?vue&type=template&id=336aac8f"
import script from "./CustomerChangeEdit.vue?vue&type=script&lang=js"
export * from "./CustomerChangeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports